import VcomProvider from './VcomProvider';
/**
 * This ensures that chunk loading works for different/longer URLs
 * e.g. system level
 * @see https://webpack.js.org/guides/public-path/#on-the-fly
 */
function initPublicPath(baseUrl) {
    // @ts-expect-error webpack global variable
    // eslint-disable-next-line camelcase
    __webpack_public_path__ = `${baseUrl}/js/`;
}
VcomProvider
    .setWebpackPublicPath = (baseUrl) => {
    initPublicPath(baseUrl);
};
export default initPublicPath;
